/**
 * 발주 우선순위 — -6차 · 발주개수 (/m/msix, 구 /m/odrcnt 흡수)
 *
 * 기사에게 "내 알림 순서를 지금 무엇이 정하고 있는지" 를 알려주는 화면.
 * -6차가 있으면 -6차가, 없으면 발주개수 차수가 순서를 정한다(둘은 배타).
 *
 *  - 요약  : 통합 전 두 화면의 상단 표(.orderTbl)를 그대로 되살린 테두리 표. 탭마다 칸이 다르다.
 *            발주개수 탭에는 그 아래로 차수 조절·수주포인트 교환(통합으로 생긴 컨트롤)이 붙는다.
 *  - 안내  : 물음표 → $j.Ui.Tooltip (세대와 무관하게 통하는 말만)
 *  - 내역  : -6차 / 발주개수 탭. 오더는 "#497567 2026-07-19 · 스카이 38~54m · 서울 송파구"
 *            번호만으로는 기사가 어느 일인지 모르고, 문장만으로는 CS 와 통화할 때 짚을 것이 없다
 */
import Util from '../../Common/Util';
export default class Msix {
    constructor() {
        this.page = 1;
        this.guide = null;
        this.recallWait = 0;      // 회수예약 개수 (내역 조회가 채운다)
        this.recallPending = 0;   // 그 예약이 가져갈 수 있는 '대기중' 카드 수
    }

    initialize() {
        if (!$('.mx6').data('owner')) return;   // 소속자는 조회 불가

        // ?tab= 으로 들어온 경우만 고정. 아니면 요약을 받아본 뒤 -6차 보유 여부로 정한다.
        this.tab = new URLSearchParams(location.search).get('tab') === 'odrcnt' ? 'odrcnt' : null;

        $('#mx6Tabs').on('click', 'button', (e) => {
            const tab = $(e.currentTarget).data('tab');
            if (tab === this.tab) return;
            this._setTab(tab);
            this._loadList(1);
        });

        $('#mx6More button').on('click', () => this._loadList(this.page + 1));
        $('#mx6List').on('click', '.mx6-line.is-link', (e) =>
            this._openOrder($(e.currentTarget).data('o')));
        this._loadSummary();   // 요약이 탭을 정하고, 그 다음 목록을 부른다
    }

    /** 탭 전환 — 요약표 + 버튼 활성 + 탭 전용 패널(차수·교환) */
    _setTab(tab) {
        this.tab = tab;
        $('#mx6Tabs button').removeClass('on').filter(`[data-tab="${tab}"]`).addClass('on');
        this._renderSum();    // 보고 있는 탭의 요약표
        // -6차 탭에는 패널이 없다 — 요약표가 곧 그 탭의 전부다(통합 전 화면과 같은 구성)
        $('#mx6Panel').html(tab === 'odrcnt' ? this._odrPanel() : '');
        if (tab === 'odrcnt') {
            this._bindChrsoo(this.odr);
            $('#mx6Exchange').off('click').on('click', () => this._openExchange());
        }
    }

    // ─────────────────────────────────────────── 요약 · 안내

    async _loadSummary() {
        try {
            const r = await $.getJSON('/m/ajax/msix/summary');
            if (!r.ok) return;
            this.guide = r.guide;
            this.pt    = r.point;   // 수주포인트 보유·환율 (교환 시트가 쓴다)
            this._renderSummary(r.summary, r.guide, r.odrcnt);
        } catch (e) {
            console.error('-6차 요약 로드 실패', e);
        }
    }

    _renderSummary(s, g, o) {
        this.sum = s; this.odr = o; this.guideData = g;

        $('#mx6HelpExpire').text(g.expire);

        // 탭 기본값 — -6차가 있으면 -6차, 없으면 발주개수 (URL 로 지정한 경우는 그대로)
        // 요약표는 _setTab 안에서 그린다(탭마다 표의 칸이 다르다).
        this._setTab(this.tab || (s.topCnt > 0 ? 'msix' : 'odrcnt'));
        this._loadList(1);
    }

    /**
     * 요약표 — 통합 전(-6차 / 발주개수 두 화면) 상단에 있던 테두리 표를 되살린 것이다.
     *
     * 통합하면서 큰 숫자 히어로 + 자원 알약뱃지 + 스탯 3칸으로 바꿨는데, 두 화면을 각각 쓰던
     * 사용자에게 "정신없다"는 반응이 나왔다. 목록은 그대로 두고 상단만 옛 표로 되돌린다.
     *   -6차     : 총발주수 | 매칭수 | 전환수 | 남은수 | 일차  (전체기간 — summary.balCnt 등)
     *   발주개수 : 현재 발주개수 | N 개
     * 도움말은 옛 화면의 [도움말?] 버튼 자리를 따라 표 오른쪽 위에 둔다.
     */
    _renderSum() {
        const s = this.sum, o = this.odr;
        if (!s || !o) return;

        const isOdr = this.tab === 'odrcnt';

        const table = isOdr
            ? `<table class="mx6-tbl">
                   <tr><th>현재 발주개수</th><td>${this._n(o.have)} 개</td></tr>
               </table>`
            : `<table class="mx6-tbl">
                   <tr><th>총발주수</th><th>매칭수</th><th>전환수</th><th>남은수</th><th>일차</th></tr>
                   <tr>
                       <td>${this._n(s.balCnt)}</td>
                       <td>${this._n(s.useCnt)}</td>
                       <td>${this._n(s.cnvCnt)}</td>
                       <td>${this._n(s.ingCnt)}</td>
                       <td>${this._n(s.topDay)}</td>
                   </tr>
               </table>`;

        // 표에 담기지 않는 상태 한 줄 — 전환 예정(오늘 밤)과 -6차 우선 적용 여부.
        // 배너 대신 표 아래 작은 글씨로 둔다(옛 화면에는 없던 정보라 눈에 덜 걸리게).
        const notes = [];
        if (!isOdr && s.expiring > 0) notes.push(`오늘 밤 <b>${s.expiring}건</b>이 발주개수로 바뀝니다.`);
        if (isOdr && o.lockedByMsix)  notes.push(`-6차 <b>${this._n(s.cnt)}건</b> 보유중 — 지금은 -6차가 먼저 적용됩니다.`);
        if (isOdr && !o.lockedByMsix) notes.push(o.chrsoo < 0 ? `<b>${o.chrsoo}차</b> 적용중` : '차수 미설정');

        $('#mx6Sum').html(`
            <div class="mx6-sum-hd">
                <button type="button" class="mx6-help"
                        data-tip-html="${isOdr ? '#mx6HelpOdrTpl' : '#mx6HelpTpl'}"
                        data-tip-title="${isOdr ? '발주개수 안내' : '-6차 안내'}" data-tip-place="bottom">
                    <i class="fas fa-question-circle"></i>도움말
                </button>
            </div>
            ${table}
            ${notes.length ? `<div class="mx6-sum-note">${notes.join(' · ')}</div>` : ''}`);
    }

    /** 발주개수 탭 패널 — 차수 조절 + 포인트 교환 (통합으로 새로 생긴 컨트롤) */
    _odrPanel() {
        return this._chrsooBox(this.odr) + this._exchangeBox();
    }

    /**
     * 차수 조절 — 환경설정과 같은 값·같은 저장 경로를 쓴다(값이 갈리지 않게)
     *
     * -6차 보유중에는 아예 그리지 않는다. 잠긴 select 를 남겨두면 '왜 안 되지' 하고
     * 만지게 되는 죽은 컨트롤이 된다. 대신 그 사실은 요약표 아래 상태줄과 안내 팝오버가 말해준다.
     */
    _chrsooBox(o) {
        if (o.lockedByMsix) return '';

        const opts = [0, -1, -2, -3, -4, -5].map(v => {
            const over = v < 0 && Math.abs(v) > o.have;   // 가진 개수보다 큰 차수는 못 고른다
            return `<option value="${v}" ${v === o.chrsoo ? 'selected' : ''} ${over ? 'disabled' : ''}>
                        ${v === 0 ? '사용 안 함' : `${v}차`}${over ? ' (개수 부족)' : ''}
                    </option>`;
        }).join('');

        const note = !o.canChrsoo
            ? '<span class="mx6-lock">소유자·유료회원만 조절할 수 있습니다</span>'
            : `<span class="mx6-chrsoo-note">낮춘 차수만큼 수주 시 발주개수가 차감됩니다</span>`;

        const disabled = o.canChrsoo ? '' : 'disabled';

        return `<div class="mx6-chrsoo ${disabled ? 'is-off' : ''}">
            <div class="mx6-chrsoo-head">
                <b>발주개수 차수</b>
                <button type="button" class="mx6-help-inline"
                        data-tip-html="#mx6HelpOdrTpl" data-tip-title="발주개수 안내" data-tip-place="bottom">
                    <i class="fas fa-question-circle"></i>
                </button>
                <select id="mx6Chrsoo" ${disabled}>${opts}</select>
            </div>
            <div class="mx6-chrsoo-sub">${note}</div>
        </div>`;
    }

    _bindChrsoo(o) {
        $('#mx6Chrsoo').off('change').on('change', (e) => {
            const v = parseInt(e.currentTarget.value, 10);
            const prev = o.chrsoo;
            if (v < 0 && Math.abs(v) > o.have) {
                Util.swalert(`발주개수가 부족합니다. (보유 ${o.have}개)`);
                e.currentTarget.value = String(prev);
                return;
            }
            // 저장은 환경설정과 같은 엔드포인트 — 두 화면이 같은 값을 쓴다
            $.post('/m/ajax/setting/save', { gokey: 'mem_ordercounter', govalue: v })
                .done(() => { o.chrsoo = v; this._loadSummary(); })
                .fail(() => {
                    Util.swalert('차수를 저장하지 못했습니다.');
                    e.currentTarget.value = String(prev);
                });
        });
    }

    // (구 _flowBox — '최근 3개월 발주개수 흐름' 막대는 상단 요약표 복원과 함께 제거했다.
    //  통합 전 화면에 없던 시각화라 '정신없다'는 반응의 한 축이었다. 되살릴 일이 생기면
    //  git 이력의 이 자리(Msix.js _flowBox)와 _msix.scss 의 .mx6-flow 를 참고한다)

    /**
     * 수주포인트 → 발주개수 교환. 예전에는 /m/point 로 보냈지만, 발주개수가 모자란 것을
     * 여기서 알고도 다른 화면까지 가야 했다. 이 자리에서 바로 바꾸고 요약을 갱신한다.
     * 실제 차감은 /m/point 와 같은 엔드포인트(PointController::exchange)를 쓴다.
     */
    _exchangeBox() {
        const p = this.pt || { have: 0, per: 100, max: 0 };
        return `<div class="mx6-ex">
            <div class="mx6-ex-info">
                ${this._item('pt')} ${this._n(p.have)}P
                <span class="mx6-ex-able">${p.max > 0 ? `${this._n(p.max)}개 교환 가능` : `${this._n(p.per)}P 부터 교환`}</span>
            </div>
            <button type="button" class="mx6-ex-btn" id="mx6Exchange" ${p.max > 0 ? '' : 'disabled'}>교환하기</button>
        </div>`;
    }

    /** 교환 시트 — 개수를 정해 바로 바꾼다 */
    _openExchange() {
        const p = this.pt || { have: 0, per: 100, max: 0 };
        if (p.max < 1) {
            Util.swalert(`수주포인트가 부족합니다. ${this._n(p.per)}P 부터 발주개수 1개로 바꿀 수 있습니다. (보유 ${this._n(p.have)}P)`);
            return;
        }
        const self = this;
        $j.Ui.BS.open({
            target: {
                init() {
                    this.parent.setTitle('수주포인트 → 발주개수 교환');
                    $('#' + this.id).html(self._exchangeForm(p));
                    self._bindExchangeForm(p);
                },
            },
        });
    }

    _exchangeForm(p) {
        return `<div class="mx6-exf">
            <div class="mx6-exf-row"><span>${this._item('pt')} 보유</span><b>${this._n(p.have)}P</b></div>
            <div class="mx6-exf-row"><span>교환 비율</span><b>${this._n(p.per)}P → ${this._item('odr')} 1개</b></div>
            <div class="mx6-exf-input">
                <input type="number" id="mx6ExCnt" inputmode="numeric" min="1" max="${p.max}" value="${p.max}">
                <span class="mx6-exf-unit">개</span>
                <button type="button" class="mx6-exf-max" id="mx6ExMax">최대 ${this._n(p.max)}개</button>
            </div>
            <div class="mx6-exf-need" id="mx6ExNeed"></div>
            <button type="button" class="mx6-exf-go" id="mx6ExGo">교환하기</button>
        </div>`;
    }

    _bindExchangeForm(p) {
        const $cnt  = $('#mx6ExCnt');
        const $need = $('#mx6ExNeed');

        // 입력값은 항상 1~최대 사이로 (직접 입력·붙여넣기 포함)
        const clamp = () => {
            let v = parseInt($cnt.val(), 10);
            if (isNaN(v) || v < 1) v = 1;
            if (v > p.max) v = p.max;
            $cnt.val(v);
            return v;
        };
        const paint = () => {
            const v = clamp();
            $need.html(`${this._n(v * p.per)}P 차감 → ${this._item('odr')} ${this._n(v)}개`);
        };

        $cnt.off('input change').on('input change', paint);
        $('#mx6ExMax').off('click').on('click', () => { $cnt.val(p.max); paint(); });
        $('#mx6ExGo').off('click').on('click', () => this._doExchange(clamp(), p));
        paint();
    }

    _doExchange(cnt, p) {
        const $go = $('#mx6ExGo');
        if ($go.prop('disabled')) return;   // 중복 전송 방지
        $go.prop('disabled', true);

        $.post('/m/ajax/point/exchange', { balamtset: cnt })
            .done((data) => {
                if (!data.result) {
                    Util.swalert(data.message || '교환하지 못했습니다.');
                    $go.prop('disabled', false);
                    return;
                }
                $j.Ui.BS.close();
                Util.swalert(`발주개수 ${this._n(cnt)}개로 교환했습니다.`);
                this._loadSummary();   // 보유 포인트·발주개수·흐름·내역까지 다시 그린다
            })
            .fail(() => {
                Util.swalert('교환하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                $go.prop('disabled', false);
            });
    }

    // ─────────────────────────────────────────── 내역

    async _loadList(page) {
        const isMsix = this.tab === 'msix';
        try {
            const r = await $.post(isMsix ? '/m/ajax/msix/list' : '/m/ajax/odrcnt/list', { page });
            if (!r.ok) return;
            this.page = r.page;

            // 회수예약(관리자가 걸어둔 앞으로 받을 -6차의 회수)은 '대기중' 카드의 경고 문구가 된다.
            // 카드마다 다시 세지 않게 목록을 그리기 전에 한 번만 계산한다.
            if (isMsix) this._markRecallWait(r);

            const html = r.rows.map(x => isMsix ? this._card(x) : this._odrCard(x)).join('');
            if (page === 1) {
                $('#mx6List').html(html || `<div class="mx6-empty">${isMsix ? '아직 받은 -6차가 없습니다.' : '발주개수 변동 내역이 없습니다.'}</div>`);
            } else {
                $('#mx6List').append(html);
            }
            $('#mx6More').toggle(!!r.hasMore);
        } catch (e) {
            console.error('-6차 내역 로드 실패', e);
        }
    }

    /**
     * 회수예약 경고를 준비한다 — 이번 목록에서 위태로운 '대기중' 이 몇 개인지.
     *
     * 예약은 개수만 걸려 있고 어느 grant 가 회수될지는 배치가 정한다(LIMIT cnt). 그래서
     * 예약이 대기중보다 적으면 "N개가 회수된다" 로만 말하고, 카드 하나를 지목하지 않는다.
     */
    _markRecallWait(r) {
        const wait    = Number(r.recallWait || 0);
        const pending = (r.rows || []).filter(x => x.state === 'live' && x.nday <= 0).length;

        // 첫 페이지가 아니면 앞 페이지에서 이미 센 대기중이 있으므로 문구만 유지한다
        this.recallWait = wait;
        if (r.page === 1) this.recallPending = pending;
        else              this.recallPending = Math.max(this.recallPending || 0, pending);
    }

    /** '대기중' 카드에 붙일 회수예약 경고 문구 — 예약이 없으면 빈 문자열 */
    _recallWarn(x) {
        if (!this.recallWait || !(x.state === 'live' && x.nday <= 0)) return '';

        const when = x.nday === 0 ? '오늘 밤' : '지급 시작일 새벽';
        const msg  = this.recallWait >= (this.recallPending || 1)
            ? `관리자 회수예약이 걸려 있어 ${when} 회수됩니다. 수주에 사용할 수 없습니다.`
            : `관리자 회수예약 ${this.recallWait}개가 걸려 있어 대기중 -6차 중 ${this.recallWait}개가 ${when} 회수됩니다.`;

        return `<div class="mx6-warn"><i class="fas fa-exclamation-triangle"></i>${msg}</div>`;
    }

    _card(x) {
        // 회수예약이 걸린 '대기중' 은 곧 회수될 자리라 경고색(is-red)으로 세운다.
        // 뱃지 글자는 '대기중' 그대로 둔다 — 어느 카드가 회수될지는 배치가 정하므로 단정하지 않는다.
        const warn = this._recallWarn(x);
        const S = {
            // nday 0 = start_date 가 아직 오지 않은 것 — 일차가 시작되기 전이라 '대기중'
            live:      { cls: warn ? 'is-red' : 'is-live', txt: x.nday > 0 ? `보유중 ${x.nday}일차` : '대기중' },
            expiring:  { cls: 'is-warn', txt: '오늘 밤 전환' },
            used:      { cls: 'is-used', txt: '수주에 사용' },
            converted: { cls: 'is-gray', txt: '발주개수로 전환' },
            canceled:  { cls: 'is-gray', txt: '발주 취소로 회수' },
            taken:     { cls: 'is-red',  txt: '관리자 회수' },
            done:      { cls: 'is-gray', txt: '사용됨' },
        }[x.state] || { cls: 'is-gray', txt: '' };

        // 본문 — 무엇으로 받았고(from), 어디에 썼는지(to)를 문장으로.
        // 오더가 실재하면 눌러서 상세(작업내용)를 볼 수 있게 한다.
        const line = (label, text, ordernum) => ordernum
            ? `<div class="mx6-line is-link" data-o="${ordernum}"><span>${label}</span>${this._no(ordernum)}${this._phrase(text)}
                   <i class="fas fa-chevron-right"></i></div>`
            : `<div class="mx6-line"><span>${label}</span>${this._phrase(text)}</div>`;

        const lines = [];
        if (x.from) lines.push(line('받음', x.from, x.fromNum));
        if (x.to)   lines.push(line('사용', x.to, x.toNum));
        if (!x.from && !x.to) lines.push(`<div class="mx6-line"><span>지급</span>관리자 지급</div>`);
        if (x.memo) lines.push(`<div class="mx6-memo">${this._esc(x.memo)}</div>`);

        return `<div class="mx6-card ${S.cls}">
            <div class="mx6-card-top">
                <span class="mx6-badge">${S.txt}</span>
            </div>
            ${lines.join('')}
            ${warn}
            ${x.state === 'live' && !warn && x.left > 0
                ? `<div class="mx6-left">${x.left}일 뒤 발주개수로 바뀝니다</div>` : ''}
        </div>`;
    }

    /** 발주개수 카드 — 증감과 사유, 관련 오더 */
    _odrCard(x) {
        const plus = x.diff > 0;
        return `<div class="mx6-card ${plus ? 'is-live' : 'is-red'}">
            <div class="mx6-card-top">
                <span class="mx6-badge">${this._esc(x.label)}</span>
                <span class="mx6-odr-diff ${plus ? 'is-plus' : 'is-minus'}">${plus ? '+' : ''}${this._n(x.diff)}개</span>
            </div>
            ${x.from ? `<div class="mx6-line ${x.fromNum ? 'is-link' : ''}" ${x.fromNum ? `data-o="${x.fromNum}"` : ''}>
                <span>오더</span>${this._no(x.fromNum)}${this._phrase(x.from)}${x.fromNum ? '<i class="fas fa-chevron-right"></i>' : ''}</div>` : ''}
            <div class="mx6-left">${this._esc(x.date)}</div>
        </div>`;
    }

    /**
     * 오더 상세 — 사용내역·수주포인트와 같은 오더상세 BS 를 띄운다.
     * -6차 화면에서는 모아볼 내역이 없으므로 작업내용만 (logs 없음).
     */
    _openOrder(ordernum) {
        $j.Ui.BS.open({ target: '$j.F.Mobile.OrderSheet', fixedHeight: true, data: { ordernum } });
    }

    // ─────────────────────────────────────────── 공용

    /**
     * 자원 이름 — 예전에는 $j.Common.Util.resItem() 의 알약 뱃지(⚡-6차 / ❤발주개수 / ⭐수주포인트)였다.
     * 회원 화면에서는 아이콘·색이 정보량 없이 시선만 끌어 "정신없다"는 반응이 나와 이름만 남긴다.
     * (resItem() 자체는 관리자 화면이 계속 쓰므로 건드리지 않는다 — 거기선 표를 훑는 표식으로 기능한다)
     */
    _item(kind) {
        return { msix: '-6차', odr: '발주개수', pt: '수주포인트' }[kind] || '';
    }

    /** 오더번호 — 오더상세 시트와 같은 `#번호` 표기. 오더가 없으면(0) 아무것도 그리지 않는다 */
    _no(num) {
        const n = parseInt(num, 10) || 0;
        return n > 0 ? `<em class="mx6-no">#${n}</em>` : '';
    }

    /**
     * 오더 문장 — 맨 앞 작업날짜에 색을 입힌다.
     * 번호(#497567)와 날짜(2026-07-19)가 숫자끼리 붙어 있어 같은 색이면 한 덩어리로 읽힌다.
     * 문장은 서버(MsixQueryService::orderPhrase)가 `날짜 · 장비 · 현장` 순으로 만든다.
     */
    _phrase(text) {
        const m = /^(\d{4}-\d{2}-\d{2})(.*)$/s.exec(text == null ? '' : String(text));
        return m ? `<em class="mx6-day">${m[1]}</em>${this._esc(m[2])}` : this._esc(text);
    }

    _n(v)   { return Number(v ?? 0).toLocaleString(); }
    _esc(s) { return $('<div>').text(s == null ? '' : String(s)).html(); }
}
